import React from 'react';
import style from './ButtonBottom.module.scss';
import clsx from 'clsx';

type ButtonColor = 'brand' | 'red' | 'green' | 'orange' | 'dark';

type ButtonBottomProps = {
  type?: 'button' | 'submit';
  color?: ButtonColor;
  disabled?: boolean;
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
};

const ButtonBottom = ({
  type = 'button',
  color = 'brand',
  disabled = false,
  children,
  onClick,
  className = '',
}: ButtonBottomProps) => {
  return (
    <button
      type={type}
      disabled={disabled}
      onClick={!disabled ? onClick : undefined}
      className={clsx(style.submitBtn, style[color], { [style.disabled]: disabled }, className)}
    >
      {children}
    </button>
  );
};

export default ButtonBottom;
